<template>
  <span class="auth-nav-container">
    <SignOnPopup v-if="currentUser === null" />
    <Avatar v-if="currentUser !== null" :user="currentUser" />
    <!-- <v-btn @click="log">click</v-btn> -->
  </span>
</template>

<script>
import Vue from 'vue'
import SignOnPopup from './SignOnPopup.vue'
import Avatar from './Avatar.vue'
import { currentUser, auth } from '@/api/firebase.js'

export default Vue.extend({
  name: 'authNav',

  components: {
    SignOnPopup,
    Avatar
  },

  data: () => ({
    currentUser: false
  }),

  created () {
    this.currentUser = currentUser()

    auth().onAuthStateChanged(user => {
      this.currentUser = user
      console.log(this.currentUser)
    })
  },

  methods: {
    log () {
      console.log(currentUser())
    }
  }

})
</script>
